import React from 'react'
import { rankWith, scopeEndsWith } from '@jsonforms/core'

import ElementWrapper from 'designer/component/display/layout/control/ElementWrapper'
import DragElementWrapper from 'designer/component/system/layout/control/DragElementWrapper'

import CustomButton from 'designer/component/element/Button'
import CustomButtonDropdown from 'designer/component/element/ButtonDropdown'

export const ButtonSystem = (props) => (
  <DragElementWrapper {...props}>
    <CustomButton {...props} />
  </DragElementWrapper>
)

export const ButtonDropdownSystem = (props) => (
  <DragElementWrapper {...props}>
    <CustomButtonDropdown {...props} />
  </DragElementWrapper>
)

export const ButtonDisplay = (props) => (
  <ElementWrapper {...props}>
    <CustomButton {...props} />
  </ElementWrapper>
)

export const ButtonDropdownDisplay = (props) => (
  <ElementWrapper {...props}>
    <CustomButtonDropdown {...props} />
  </ElementWrapper>
)

export const buttonTester = rankWith(1000, scopeEndsWith('button'))
export const buttonDropdownTester = rankWith(
  1000,
  scopeEndsWith('buttonDropdown')
)
